import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import GenericModal from "src/components/GenericModal/GenericModal";

interface HandOverConfirmModalProps {
  isOpen: boolean;
  onClose: (dontShowAgain: boolean) => void;
  onConfirm: (e: React.MouseEvent, dontShowAgain: boolean) => void;
}

export const HandOverConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
}: HandOverConfirmModalProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleConfirm = (e: React.MouseEvent) => {
    onConfirm(e, dontShowAgain);
  };

  const handleCancel = () => {
    onClose(dontShowAgain);
  };

  return (
    <GenericModal
      isOpen={isOpen}
      title="Delegate to Qara"
      description="Kick off a background run to let your Agent create a first draft of all the answers required for the document and come back when completed. The agent will provide draft answers to you and you have full control to apply and edit them. This action will take a few minutes."
      handleCancel={handleCancel}
      handleSave={handleConfirm}
      width="50%"
      saveText="Continue"
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={dontShowAgain}
            onChange={(e) => {
              e.stopPropagation();
              setDontShowAgain(e.target.checked);
            }}
            size="small"
          />
        }
        label="Don't show me this again"
        onClick={(e) => e.stopPropagation()}
      />
    </GenericModal>
  );
};
